"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _index = _interopRequireDefault(require("./index.js"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'form-post-editor';
exports.cssAnchorName = cssAnchorName;

var FormPostEditor = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(FormPostEditor, _Component);

  var _super = _createSuper(FormPostEditor);

  function FormPostEditor() {
    var _this;

    (0, _classCallCheck2.default)(this, FormPostEditor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      attachments: [],
      hasFileInProgress: false,
      content: '',
      poll: {
        question: '',
        options: []
      }
    });
    return _this;
  }

  (0, _createClass2.default)(FormPostEditor, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var createBtn = document.querySelector('button#topic_save');
      var loaderMessage = document.querySelector('#file-in-progress-message');

      if (createBtn && loaderMessage) {
        createBtn.disabled = this.state.hasFileInProgress;

        if (this.state.hasFileInProgress) {
          loaderMessage.classList.remove('is-hidden');
        } else {
          loaderMessage.classList.add('is-hidden');
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          disableFileAttachments = _this$props.disableFileAttachments,
          contentInputName = _this$props.contentInputName,
          contentPollInputName = _this$props.contentPollInputName,
          contentPollOptionsInputName = _this$props.contentPollOptionsInputName,
          attachmentsInputName = _this$props.attachmentsInputName;
      return (0, _preact.h)("div", null, (0, _preact.h)(_index.default, (0, _extends2.default)({}, this.props, {
        isControl: false,
        disableFileAttachments: disableFileAttachments,
        onChange: function onChange(content, attachments, hasFileInProgress) {
          return _this2.setState({
            content: content,
            attachments: attachments,
            hasFileInProgress: hasFileInProgress
          });
        },
        placeholder: "new.topic.placeholder.textarea",
        onPollUpdate: function onPollUpdate(poll) {
          _this2.setState({
            poll: poll
          });
        },
        canHavePoll: true
      })), (0, _preact.h)("input", {
        type: "hidden",
        name: contentInputName,
        value: this.state.content
      }), (0, _preact.h)("input", {
        type: "hidden",
        name: contentPollInputName,
        value: this.state.poll.question
      }), this.state.poll.options.map(function (option) {
        return (0, _preact.h)("input", {
          type: "hidden",
          name: contentPollOptionsInputName,
          value: option,
          key: option
        });
      }), this.state.attachments.map(function (attachment) {
        return (0, _preact.h)("input", {
          type: "hidden",
          name: attachmentsInputName,
          value: JSON.stringify(attachment),
          key: attachment.id
        });
      }));
    }
  }]);
  return FormPostEditor;
}(_preact.Component);

exports.default = FormPostEditor;